import { format } from 'date-fns';
import React, { useEffect, useState } from 'react';
import { FiTrendingUp } from 'react-icons/fi';
import useFetchData from '../../../hooks/useFetchData';

const TodaySales = () => {
    const date = new Date();
    const today = format(date, "yyyy-MM-dd");

    const { items: profit } = useFetchData("https://servers.thakurgaonexpress.com/rupkotha/daywiseprofit");

    const todayProfit = (Array.isArray(profit) ? profit : []).filter(pf => pf.day === today);


    return (
        // <div class="mx-auto w-11/12 bg-coral text-textPrimary rounded-lg overflow-hidden bg-[#FFE6FF] shadow-lg glassmorphism p-5">
       <div class="modern-card p-5">
            <div className='flex justify-between items-center'>
                <div class="flex flex-col justify-center items-center">
                    <div class="text-sm font-semibold mb-2">Today Profit</div>
                    <p class="text-xl text-textPrimary">৳ {todayProfit[0]?.profit ? (todayProfit[0]?.profit).toFixed(2) : 0.00}</p>
                </div>
                <div className="dashboard-stat-card__icon"><FiTrendingUp /></div>
            </div>
        </div>
    );
};

export default TodaySales;
